import { AxiosInstance } from "axios";
import { createAuthInterceptor } from "./auth-interceptor";
import { createErrorInterceptor } from "./error-interceptor";
import { multipartInterceptor } from "./multipart-interceptor";
import { queryInterceptor } from "./query-interceptor";
import { successInterceptor } from "./success-interceptor";
import { SessionClient } from "../../../domain/clients";

export const setupInterceptors = (
  instance: AxiosInstance,
  sessionClient: SessionClient
) => {
  // Ordem importante: request primeiro, response depois
  instance.interceptors.request.use(queryInterceptor);
  instance.interceptors.request.use(createAuthInterceptor(sessionClient));
  instance.interceptors.request.use(multipartInterceptor);

  instance.interceptors.response.use(
    successInterceptor,
    createErrorInterceptor(sessionClient)
  );

  return instance;
};

export * from "./auth-interceptor";
export * from "./error-interceptor";
export * from "./multipart-interceptor";
export * from "./query-interceptor";
export * from "./success-interceptor";
